import React, {Component} from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import './chatHelpCardGrid.scss';
import {withStyles} from "@material-ui/core";
import Hidden from '@material-ui/core/Hidden';
import {Billing} from './chatHelp-Icons';
import {TV} from './chatHelp-Icons';
import {Voice} from './chatHelp-Icons';
import {AppSupport} from './chatHelp-Icons';
import {XAIcon} from './chatHelp-Icons';
import {ForgotUserNamePassword} from './chatHelp-Icons';
import {Internet} from './chatHelp-Icons';
import {XfinityMobile} from './chatHelp-Icons';
import {Home} from './chatHelp-Icons';
import {RemotePairing} from "./chatHelp-Icons";
import Link from '@material-ui/core/Link';

const styles = () => ({
  title: {
    width: '100%'
  }
});

class chatHelpCardGrid extends Component {


  constructor(props){
    super(props);
    this.onGridKeyClicked = this.onGridKeyClicked.bind(this);
    this.onGridItemClicked = this.onGridItemClicked.bind(this);
  }

  renderImages(card,height,padding,width) {
    switch (card.icon) {
      case "Billing":
        return <Billing height={height} padding={padding} width={width}/>
      case "RemotePairing":
        return <RemotePairing height={height} padding={padding} width={width}/>
      case "TV":
        return <TV height={height} padding={padding} width={width}/>
      case "Voice":
        return <Voice  height={height} padding={padding} width={width}/>
      case "XAIcon":
        return <XAIcon  height={height} padding={padding} width={width}/>
      case "ForgotUserNamePassword":
        return <ForgotUserNamePassword  height={height} padding={padding} width={width}/>
      case "Internet":
        return <Internet  height={height} padding={padding} width={width}/>
      case "XfinityMobile":
        return <XfinityMobile  height={height} padding={padding} width={width}/>
      case "AppSupport":
        return <AppSupport  height={height} padding={padding} width={width}/>
      case "Home":
        return <Home height={height} padding={padding} width={width}/>
    }
  }

  onGridKeyClicked(event,title)
  {

    if (event.keyCode === 13) {
      event.preventDefault();
      this.props.defaultEvent( title,'intent');

    }
  }

  onGridItemClicked(event, card)
  {
     //this.props.defaultEvent( event.currentTarget.innerText,'intent');
    this.props.defaultEvent( event.currentTarget.getAttribute('value'),'intent');
    //event.currentTarget.getAttribute('value')
  }
  render() {
    const cards=this.props.cards;
    return <Grid
                data-tracking='{"container":["xa-chat-help"]}'
                 container
                 direction="row"
                 justify="center"
                 className={'chatHelp-card-grid-container'}
                 alignItems="center">
      <Grid item xs={12} className={'chatHelp-card-grid'}>
        <Hidden xsDown>
        <h3 role='text' aria-label={cards.cardHeading}  tabIndex='-1' className='chatHelp-card-grid-title'>{cards.cardHeading}</h3>
        </Hidden>
        <Hidden smUp>
          <h3   role='text' aria-label={cards.cardHeading} tabIndex='-1' className='chatHelp-card-grid-title-small'>{cards.cardHeading}</h3>
        </Hidden>
        <Grid data-tracking-parent data-tracking='{"container":["xa-chat-help-cards"]}' container
              direction="row"
              spacing={16}
              justify="center"
              alignItems="center">
          {cards.cardItems.map((card,index) =>
            <Grid item tabIndex='0' role='link' data-tracking key={index} md={4} sm={6} xs={12} onKeyDown={(event)=>{this.onGridKeyClicked(event,card.title,'intent')}} className={'chatHelp-card-grid-item-container'}>
              <Hidden xsDown>
                <Link data-tracking='{"container":["xa-chat-help-cards-web"]}' className={"link-wrapper"}>
                  <Paper className='chatHelp-card-grid-item'  value={card.intent} onClick={(event)=>{this.onGridItemClicked(event,card.title,'intent')}}>
                    {this.renderImages(card,76,0)}
                    <br/>
                    <br/><span className={'chatHelp-card-grid-item-title'}>{card.title}</span>
                  </Paper>
                </Link>
              </Hidden>
              <Hidden smUp>
                <Link data-tracking='{"container":["xa-chat-help-cards-mobile"]}' className="link-wrapper">
                <Paper className='chatHelp-card-grid-item-small' value={card.intent} onClick={(event)=>{this.onGridItemClicked(event,card.title,'intent')}}>
                <Grid container
                      direction="row"
                      justify="center"
                      alignItems="center">
                  <Grid item xs={6}>
                    {this.renderImages(card,76,12,93)}
                  </Grid>
                  <Grid item xs={6} container
                        direction="column"
                        justify="center"
                        alignItems="center">
                    <Grid item xs={12} className={'title-container'}>
                      <span className={'chatHelp-card-grid-item-title-small'}>{card.title}</span>
                    </Grid>
                  </Grid>
                </Grid>
                </Paper>
                </Link>
              </Hidden>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  }
}

export default withStyles(styles)(chatHelpCardGrid);
